import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SignInForm from "../components/SignInForm";

import * as action from "../actions/authAction";
import * as selector from "../selectors/authSelector";

@connect(
	state => ({
		isLoading: selector.isLoadingSelector(state),
		isError: selector.isErrorSelector(state),
		authForm: selector.authFormSelector(state)
	}),
	{
		initSignIn: action.initSignIn,
		sendSignIn: action.sendSignIn.request
	}
)
export default class SignInContainer extends Component {
	static propTypes = {
		isLoading: PropTypes.bool,
		isError: PropTypes.bool,
		authForm: PropTypes.object,

		initSignIn: PropTypes.func,
		sendSignIn: PropTypes.func
	};

	constructor(props) {
		super(props);
		props.initSignIn();
	}

	render() {
		const { isLoading, isError, authForm, sendSignIn } = this.props;

		return (
			<div className="auth-wrapper">
				<div className="auth-content">
					<div className="auth-bg">
						<span className="r" />
						<span className="r s" />
						<span className="r s" />
						<span className="r" />
					</div>
					<div className="card">
						<div className="card-body text-center">
							<SignInForm
								initialValues={authForm}
								isLoading={isLoading}
								isError={isError}
								onSubmit={sendSignIn}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
